exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.notification-bar {\n  margin-left: 0;\n  transition: margin-left 0.2s ease;\n}\n.notification-bar.visible {\n  margin-left: 350px;\n}\n.notification-bar__cards {\n  overflow-y: auto;\n  height: 90vh;\n}\n.notification-bar__card {\n  background: #ffffff;\n  font-size: 14px;\n}\n.notification-bar__time {\n  font-size: 12px;\n}\n.notification-bar__badge {\n  background: #BE5A09;\n  color: #ffffff;\n  font-size: 12px;\n  top: 0;\n  right: 0;\n}", ""]);

// exports
